import { Route, Routes } from 'react-router-dom';
import { RequireRole, SessionGate } from './auth/session';
import { Layout } from './components/Layout';
import { Explore } from './routes/Explore';
import { FindingPage } from './routes/FindingPage';
import { MapsPage } from './routes/MapsPage';
import { NotFound } from './routes/NotFound';
import { Participate } from './routes/Participate';
import { Pilots } from './routes/Pilots';
import { ProjectPage } from './routes/ProjectPage';
import { EditProjectSetup, NewProject } from './routes/ProjectSetup';
import { Report } from './routes/Report';
import { SourcePage } from './routes/SourcePage';
import { AnalysisReview } from './routes/steward/AnalysisReview';
import { ExportComposer } from './routes/steward/ExportComposer';
import { Operations } from './routes/steward/Operations';
import { ReviewQueue } from './routes/steward/ReviewQueue';

export function App() {
  return (
    <SessionGate>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Report />} />
          <Route path="findings/:id" element={<FindingPage />} />
          <Route path="sources/:id" element={<SourcePage />} />
          <Route path="explore" element={<Explore />} />
          <Route path="maps" element={<MapsPage />} />
          <Route path="participate" element={<Participate />} />
          <Route path="pilots" element={<Pilots />} />
          <Route path="projects/new" element={<NewProject />} />
          <Route path="projects/:id" element={<ProjectPage />} />
          <Route path="projects/:id/setup" element={<EditProjectSetup />} />
          <Route
            path="steward"
            element={
              <RequireRole role="steward">
                <ReviewQueue />
              </RequireRole>
            }
          />
          <Route
            path="steward/exports"
            element={
              <RequireRole role="steward">
                <ExportComposer />
              </RequireRole>
            }
          />
          <Route
            path="steward/operations"
            element={
              <RequireRole role="steward">
                <Operations />
              </RequireRole>
            }
          />
          <Route
            path="steward/analysis"
            element={
              <RequireRole role="steward">
                <AnalysisReview />
              </RequireRole>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </SessionGate>
  );
}
